import * as React from "react";
import { filter } from "graphql-anywhere";
import { makeStyles } from "@mui/styles";
import { fragments as orderArtworkChangesTableFragments } from "./components/OrderArtworkChangesTable/graph";
import { fragments as orderStatusHistoryTableFragments } from "./components/OrderStatusHistoryTable/graph";
import { query } from "./graph";
import { useQuery } from "@apollo/client";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import OrderArtworkChangesTable from "./components/OrderArtworkChangesTable";
import OrderStatusHistoryTable from "./components/OrderStatusHistoryTable";
import PendingStatusView from "../../../../../components/PendingStatusView";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  artChangesContainer: {
    marginBottom: theme.spacing(2)
  },
  titleSpacing: {
    margin: theme.spacing(1)
  }
}));

const OrderStatusHistorySummary = ({ orderId }) => {
  const classes = useStyles();

  const { data, loading, error } = useQuery(query, {
    variables: { orderId }
  });

  return (
    <Card aria-labelledby="order-status-history-summary">
      <CardContent>
        {!data ? (
          <PendingStatusView status="Waiting" />
        ) : loading ? (
          <PendingStatusView status="Loading" />
        ) : error ? (
          <Typography variant="body2" color="error">
            There was an error while attempting to load the order
          </Typography>
        ) : !data.order ? (
          <Typography variant="body2" color="error">
            Unfortunately, that order could not be located
          </Typography>
        ) : (
          <React.Fragment>
            <div className={classes.artChangesContainer}>
              <Typography variant="h6" className={classes.titleSpacing}>
                Art Changes
              </Typography>
              <OrderArtworkChangesTable
                artworkChanges={filter(
                  orderArtworkChangesTableFragments.artworkChanges,
                  data.order.artworkChanges
                )}
              />
            </div>
            <Typography variant="h6" className={classes.titleSpacing}>
              Order Status History
            </Typography>
            <OrderStatusHistoryTable
              statusHistory={filter(
                orderStatusHistoryTableFragments.statusHistory,
                data.order.statusHistory
              )}
            />
          </React.Fragment>
        )}
      </CardContent>
    </Card>
  );
};

export default OrderStatusHistorySummary;
